import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

const StyledToastContainer = styled(ToastContainer)`

	// ----------no trannsition----------//
  .no-enter {
    animation: fadeIn 1ms forwards;
  }
  .no-exit {
    animation: fadeOut 1ms forwards;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  @keyframes fadeOut {
    from { opacity: 1; }
    to   { opacity: 0; }
  }

&.custom-toast-container{
		position: absolute;
		width: 378px;
		bottom: 24px;

		@media (max-width: 480px){
			width: 320px;
			bottom: 40px;
			left: 50%;
    	transform: translateX(-50%);
		}
		.Toastify__toast-theme--light{
			background: var(--defaultBgColor);
			color: var(--secondaryTextColor);
		}		
}

	.Toastify__toast-theme--light{
		background: var(--defaultBgColor);
		color: var(--secondaryTextColor);
	}		

	// ---------Invalid Toast ----------------//

	.invalid-error-toast{
		width: 370px;
		padding-block: 10px;
		border-radius: 6px;
		@media (max-width: 480px){
			width: 320px;
		}
		background: var(--defaultBgColor);
	}
	
	.invalid-error-toast .invalid-label {
			display: flex;
			align-items: center;
			gap: 4px;
	}
	.invalid-error-toast .invalid-label.invalid-label--top-align {
			align-items: center;
			gap:8px;
	}
	.invalid-error-toast .invalid-label.invalid-label--top-align svg{
		min-width: 20px;
    height: 18px;
		top: 0px;
	}
	.invalid-error-toast .invalid-label.invalid-label--top-align label.invalid-label--message-font{
		font-weight: 500;
    font-size: 15px;
	}   
	.invalid-error-toast .invalid-label label{
			font-weight: 600;
			color: var(--textTitleColor);
			font-size: 16px;
			line-height: 18px;
	}
	.invalid-error-toast .invalid-label svg{
			position: relative;
			top: -2px;
	}
	.invalid-error-toast .invalid-label label.invalid-label--message-font{
			font-weight: 400;
			font-size: 14px;
			color: inherit;
	}
	.invalid-error-toast .undo-toast-wrap {
			display: flex;
			padding-top: 0;
			align-items: center;
			font-size: 14px;
			justify-content: space-between;
			gap:2px;
			color:var(--subHeadingColor);
	}
	.invalid-error-toast .undo-toast-wrap button#undo {
			background: var(--modalBorderColor) !important;
			height: 30px;
			min-width: 56px;
			min-height: 30px;
			border-radius: 4px;
			color: var(--subHeadingColor);
			border: 1px solid rgb(199 202 207 / 38%);
			font-size: 13px;
			gap: 5px;
			padding: 0px 10px;
			transform: scale(1,1) !important;
			white-space: nowrap;
	}
	.invalid-error-toast .undo-toast-wrap button#undo svg{
		width: 16px;
		height: 16px;
		min-width: 14px;
		transform: scale(-1,1) !important;
	}
	.invalid-error-toast .invalid-label button#exit-map-only-btn {
			background: var(--primary);
			height: 30px;
			min-width: 56px;
			min-height: 30px;
			border-radius: 4px;
			color: var(--btnLabel);
			border: 1px solid var(--primary);
			font-size: 13px;
			padding: 0px 10px;
			cursor: pointer;
			white-space: nowrap;
			margin-left: auto;
			flex-shrink: 0;
	}
	.invalid-error-toast button.cancel-prompt {
			position: absolute;
			right: 2px;
			background: var(--defaultBgColor);
			height: 30px;
			width: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			top: 2px;
	}
	.invalid-error-toast button.cancel-prompt svg{
			width: 14px;
			height: 14px;
	}
//  ----------------------
`;

const Button = styled.button`
		border: none;
		color: var(--subHeadingColor);
		padding: .125rem .35rem;
		box-shadow: none;
		background: none;
		position: relative;
		top: 2px;
		cursor: pointer;
`;

export {
	Button,
	StyledToastContainer,
};
